import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import ReactLoading from 'react-loading'
import { deleteSupplier, closeDeleteSupplierModal } from 'redux/actions/suppliers'

const DeleteModal = ({ isOpen, closeModal, supplier, deleteSupplier, isLoading, source, history }) => !supplier ? null : (
  <Modal isOpen={isOpen} fade={false} toggle={closeModal} className="warning">
    <ModalHeader toggle={closeModal}>Eliminar Proveedor</ModalHeader>
    <ModalBody>
      Estás seguro de que quieres borrar al proveedor {supplier.name} ?
    </ModalBody>
    <ModalFooter>
      <Button disabled={isLoading} color="warning" className="mr-1" onClick={() => deleteSupplier({supplier, source, history})}>
        {isLoading && <ReactLoading type="spinningBubbles" color="#fff" height={10} width={10} className="d-inline-block mr-4 ml-2" />}
        Eliminar
      </Button>
      <Button disabled={isLoading} color="primary" onClick={closeModal}>Cancelar</Button>
    </ModalFooter>
  </Modal>
)

DeleteModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool,
  supplier: PropTypes.shape({
    name: PropTypes.string.isRequired
  }),
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired,
  source: PropTypes.string,
  closeModal: PropTypes.func.isRequired,
  deleteSupplier: PropTypes.func.isRequired,
}

const mapStateToProps = ({ suppliers: { openedDeleteSupplierModal, selectedSupplier, deletingSupplier }}) => {
  return ({
    isOpen: openedDeleteSupplierModal,
    supplier: selectedSupplier,
    isLoading: deletingSupplier
  })
}

const mapDispatchToProps = dispatch => ({
  deleteSupplier: info => dispatch(deleteSupplier(info)),
  closeModal: () => dispatch(closeDeleteSupplierModal()),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DeleteModal))
